"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable-next-line:variable-name

exports.__types = true; // Exporting something to force webpack to include this file